export default __webpack_public_path__ + "823a972474ecc6907d3663657a12ef1d.png";